import * as React from "react"
import { Badge } from "@/components/ui/badge"
import { cn } from "@/lib/utils"

interface SectionLabelProps extends React.ComponentProps<"div"> {
  label: string
  pulsing?: boolean
}

export function SectionLabel({ label, pulsing = false, className, ...props }: SectionLabelProps) {
  return (
    <div className={cn("flex justify-center mb-6", className)} {...props}>
      <Badge variant="section-label">
        <span 
          className={cn(
            "h-2 w-2 rounded-full bg-accent",
            pulsing && "animate-pulse-gentle"
          )} 
          aria-hidden="true"
        />
        <span>{label}</span>
      </Badge>
    </div>
  )
}
